import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, ref } from "vue";
import FiltersDesign from "@/components/base/filters/FiltersDesign.vue";
import FiltersDialog from "@/components/base/filters/FiltersDialog.vue";
import { useWindowResize } from "@/utils/useWindowSize";
import { DebtorsFilters } from "@/services/TablePage/debtors";
import store from "@/store";
import { useDebtorsStore } from "@/store_v3/DebtorsStore";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'DebtorsFilters',
  setup(__props, { expose }) {

const { width } = useWindowResize();
const isDesktop = computed(() => width.value >= 768);
const isFullWidth = computed(() => width.value <= 576);
const getWidth = computed(() => isDesktop.value ? 676 : isFullWidth.value ? 576 : 340);

const isShowFilters = ref(false);
const filters = ref<DebtorsFilters>(null);
const { isNeedUpdateDebtors } = storeToRefs(useDebtorsStore());

onBeforeMount( () => {
    store.commit('SET_FILTERS_PARAMS_OBJECT', {});
    store.commit('SET_DEFAULT_FILTERS_PARAMS_OBJECT', {});
    filters.value = new DebtorsFilters();
    filters.value.setDefaultFilters();
});

const submitFilters = () => {
    isNeedUpdateDebtors.value = true;
    isShowFilters.value = false;
};

const clearFilters = () => {
    isNeedUpdateDebtors.value = true;
    filters.value.parseRoute();
};

expose({ filters });

return { __sfc: true,width, isDesktop, isFullWidth, getWidth, isShowFilters, filters, isNeedUpdateDebtors, submitFilters, clearFilters, FiltersDesign, FiltersDialog }
}

})